/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const TagFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Tag filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M2 4.637v6.817c0 .7.278 1.37.772 1.864l7.91 7.91a2.637 2.637 0 0 0 3.728 0l6.818-6.818a2.637 2.637 0 0 0 0-3.728l-7.91-7.91A2.64 2.64 0 0 0 11.454 2H4.637A2.637 2.637 0 0 0 2 4.637M7.273 9.91a2.637 2.637 0 1 0 0-5.274 2.637 2.637 0 0 0 0 5.274"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const TagFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'tag-filled-icon'}
      icon={TagFilled}
      {...props}
      size={size}
    />
  );
};
